export default {
    'commercial-invoices': 'Commercial Invoices',
    'the-commercial-invoice': 'the commercial invoice?',
    'add-a-commercial-invoice': 'Add a commercial invoice',
    'commercial-invoice': 'commercial invoice',
}